import React from 'react';
import { Container, Typography, Box, Grid, Card, Stack } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import TargetIcon from '@mui/icons-material/TrackChanges';
import BuildIcon from '@mui/icons-material/Build';

const highlights = [
  {
    icon: TimelineIcon,
    title: '25+ yıl deneyim',
    description: 'Kurumsal süreçleri mevzuat ve operasyon gerçeğiyle birlikte değerlendiriyoruz.',
  },
  {
    icon: TargetIcon,
    title: 'İhtiyaca göre çözüm',
    description: 'Her kurum için aynı şablonu değil, uygulanabilir aksiyon planını kuruyoruz.',
  },
  {
    icon: BuildIcon,
    title: 'Sürdürülebilir kurulum',
    description: 'Politika üretmekle kalmıyor, teknik uygulamanın takibini de yapıyoruz.',
  },
];

const About = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100%',
          height: '100%',
          opacity: 0.08,
          backgroundImage: 'radial-gradient(rgba(89,208,255,0.4) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Stack spacing={3}>
              <Typography
                sx={{
                  color: 'primary.main',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                Hakkımızda
              </Typography>
              <Typography variant="h2">
                Mevzuatı, teknolojiyi ve operasyonu aynı masada buluşturuyoruz
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                GNC Veri Teknolojileri 2007’den bu yana kurumlara KVKK uyumu, bilgi güvenliği
                ve süreç tasarımı konularında danışmanlık verir. Amacımız yalnızca belge
                hazırlamak değil; kurumun gerçekten çalıştırabileceği bir güvenlik ve uyum
                sistemi kurmaktır.
              </Typography>

              <Card sx={{ p: 4 }}>
                <Typography variant="h3" sx={{ mb: 2 }}>
                  Yaklaşımımız
                </Typography>
                <Typography color="text.secondary" sx={{ mb: 2 }}>
                  Her projede önce riskleri, veri temas noktalarını ve ekip sorumluluklarını
                  netleştiriyoruz.
                </Typography>
                <Typography color="text.secondary">
                  Sonrasında süreç, eğitim ve teknik altyapıyı birbirine bağlayan uygulanabilir
                  bir yol haritası çıkarıyoruz.
                </Typography>
              </Card>
            </Stack>
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack spacing={3}>
              {highlights.map((item) => (
                <Card key={item.title} sx={{ p: 3.5 }}>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 56,
                      height: 56,
                      mb: 2.5,
                      borderRadius: 3,
                      bgcolor: 'rgba(89, 208, 255, 0.12)',
                      color: 'primary.main',
                      border: '1px solid rgba(89, 208, 255, 0.22)',
                    }}
                  >
                    <item.icon />
                  </Box>
                  <Typography variant="h3" sx={{ mb: 1.2 }}>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary">{item.description}</Typography>
                </Card>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
